import { Component, HostListener, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { TableGeneral } from '../Admin/adnetwork/adnetwork';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersAuthService } from 'src/app/users-auth.service';
import { take, timeout } from 'rxjs/operators';
import { getLocaleDateTimeFormat } from '@angular/common';
import { switchMap } from "rxjs/operators" // RxJS v6
import { ApiService } from 'src/app/Services/api.service';
import data_settingMAO from '../../assets/json/MaoProject.json';

import { CollaboratorCampaignsComponent } from '../Admin/collaborator-campaigns/collaborator-campaigns.component';
import { UtilityService } from '../Services/utility.service';
import { ApijsonService } from '../apijson.service';
import { DataService } from '../data.service';


const hostGeneral = data_settingMAO.RestApi;



declare const $: any;

export let xx: any;
//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}


export let ROUTES: RouteInfo[] = [];

//Menu Items
export const ROUTESY: RouteInfo[] = [{
    path: '/admin',
    title: 'Admin',
    type: 'sub',
    icontype: 'dashboard',
    collapse: 'varios',
    children: [
        { path: 'opcion1', title: 'Opcion 1', ab: 'B' },
        { path: 'vertical', title: 'Vertical', ab: 'GS' },
        { path: 'publisher', title: 'Publisher', ab: 'P' },
        { path: 'adnetwork', title: 'Ad Network', ab: 'P' },
        { path: "adnetworkapi", title: "Ad Network API's", ab: "P" },
        { path: 'landing', title: 'Landing Page', ab: 'P' },
        { path: 'menu', title: 'Menus', ab: 'P' },
        { path: 'rol', title: 'Rol', ab: 'P' },
        { path: 'menurole', title: 'Menu by Role', ab: 'P' },
        { path: 'reporting', title: 'Advertiser', ab: 'AR' },
        { path: 'publisherreporting', title: 'Publisher ', ab: 'PR' },
        { path: 'reports', title: 'Admin Report', ab: 'RP' },
        // { path: 'componente', title: 'Titulo visible', ab: 'RP' },

    ]
}, {
    path: '/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'dashboard'
}, {
    path: '/components',
    title: 'Components',
    type: 'sub',
    icontype: 'apps',
    collapse: 'components',
    children: [
        { path: 'buttons', title: 'Buttons', ab: 'B' },
        { path: 'grid', title: 'Grid System', ab: 'GS' },
        { path: 'panels', title: 'Panels', ab: 'P' },
        { path: 'sweet-alert', title: 'Sweet Alert', ab: 'SA' },
        { path: 'notifications', title: 'Notifications', ab: 'N' },
        { path: 'icons', title: 'Icons', ab: 'I' },
        { path: 'typography', title: 'Typography', ab: 'T' }
    ]
}, {
    path: '/forms',
    title: 'Forms',
    type: 'sub',
    icontype: 'content_paste',
    collapse: 'forms',
    children: [
        { path: 'regular', title: 'Regular Forms', ab: 'RF' },
        { path: 'extended', title: 'Extended Forms', ab: 'EF' },
        { path: 'validation', title: 'Validation Forms', ab: 'VF' },
        { path: 'wizard', title: 'Wizard', ab: 'W' }
    ]
}, {
    path: '/tables',
    title: 'Tables',
    type: 'sub',
    icontype: 'grid_on',
    collapse: 'tables',
    children: [
        { path: 'regular', title: 'Regular Tables', ab: 'RT' },
        { path: 'extended', title: 'Extended Tables', ab: 'ET' },
        { path: 'datatables.net', title: 'Datatables.net', ab: 'DT' }
    ]
}, {
    path: '/maps',
    title: 'Maps',
    type: 'sub',
    icontype: 'place',
    collapse: 'maps',
    children: [
        { path: 'google', title: 'Google Maps', ab: 'GM' },
        { path: 'fullscreen', title: 'Full Screen Map', ab: 'FSM' },
        { path: 'vector', title: 'Vector Map', ab: 'VM' }
    ]
}, {
    path: '/widgets',
    title: 'Widgets',
    type: 'link',
    icontype: 'widgets'

}, {
    path: '/charts',
    title: 'Charts',
    type: 'link',
    icontype: 'timeline'

}, {
    path: '/calendar',
    title: 'Calendar',
    type: 'link',
    icontype: 'date_range'
}, {
    path: '/pages',
    title: 'Pages',
    type: 'sub',
    icontype: 'image',
    collapse: 'pages',
    children: [
        { path: 'pricing', title: 'Pricing', ab: 'P' },
        { path: 'timeline', title: 'Timeline Page', ab: 'TP' },
        //{path: 'login', title: 'Login Page', ab:'LP'},
        { path: 'register', title: 'Register Page', ab: 'RP' },
        { path: 'lock', title: 'Lock Screen Page', ab: 'LSP' },
        { path: 'user', title: 'User Page', ab: 'UP' }
    ]
}
];

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.css']
})



export class SidebarComponent implements OnInit {
    ROUTE2: any[];
    public menuItems: any[];
    tbl: TableGeneral;
    MenuList: any[];
    MenuList2: any[];
    MenuJLF: any[];
    GeneralMenus: any[];
    UserName: string;
    InitName: string = "";
    paramDeveloper: string;
    myItemSession: any;
    AdFeedList: any = [];
    RoleID: any;
    RoleName: string;
    VerticalList: any = [];
    IsMobile: boolean = false;
    verticalIcons: any = [];
    LoggedUser: any = {};
    breadCrumbList = [];
    
    developmentTests: boolean = false;
    preprodTests: boolean = false;

    body = 'This is example. \none\ntwo';
    constructor(private apiService: ApiService,
        private http: HttpClient,
        private userAuth: UsersAuthService,
        private _router: Router,
        private route: ActivatedRoute,
        private apiJsonService: ApijsonService,
        private data: DataService
    ) {

        this.myItemSession = localStorage.getItem("SessionMAO");
        this.myItemSession = JSON.parse(this.myItemSession);
        this.RoleID = this.myItemSession.RoleID;
        this.RoleName = this.myItemSession.RoleName || '(undefined role)';
        
        if(hostGeneral.includes('maopreprodadminapi-frcaayfwakfdhxe6.centralus-01.azurewebsites.net')){
            this.preprodTests = true;
        }

        if (hostGeneral.includes('maodevadminuiapi.azurewebsites.net') || hostGeneral.includes('dev.adminapi.myadoptimizer.com')) {
            this.developmentTests = true;
        }
    }

    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    SelectedMenu(index) {
        // var items = document.getElementsByClassName("nav-link ng-star-inserted");
        // var x;
        // var itemName = "";
        // if (items.length > 0) {
        //     for (var i = 0; i < items.length; i++) {
        //         x = items[i];
        //         itemName = x.hash;
        //         items[i].setAttribute("aria-expanded", "false");
        //         if (i != 3)
        //             $(itemName).removeClass("show");
        //         else
        //             items[3].classList.remove("show");
        //         items[i].parentNode["classList"].remove("active")
        //     }
        //     items[index].setAttribute("aria-expanded", "true");
        //     var lista = items[3].parentNode;
        //     items[index].parentNode["classList"].add("active")
        // }

    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        const isMobile = window.innerWidth <= 990;
        if (isMobile) {
            this.IsMobile = true;
        }
        else {
            this.IsMobile = false;
        }
    }

    ngOnInit() {

        let id = this.route.snapshot.paramMap.get('id');
        const paramd = this.route.snapshot.paramMap.get("id");
        //console.log("id 3:" + id);
        //console.log("const 3:" + paramd);
        this.UserName = "User";

        const isMobile = window.innerWidth <= 990;
        if (isMobile) {
            // Aplicar reordenamiento solo en vista móvil
            this.IsMobile = true;
        }

        this.userAuth.VerifyCredentials().subscribe((isValid: boolean) => {
            if (isValid) {
                this.getListMenu();
            } else {
                this.Logout();
            }
        });



        (function ($) {
            $(document).ready(function () {
                setTimeout(() => {

                }, 3000);
            });
        })($);

    }


    SetTitle(title) {
        //localStorage.setItem("SessionMAO");
        localStorage.setItem('TitlePage', title);
    }

    SetVerticalWithAdFeed() {
        var Menus = []

        if (this.VerticalList.length > 0) {
            if (this.AdFeedList.length > 0) {
                this.VerticalList.forEach(vertical => {
                    var item = {
                        "MenuID": vertical.VerticalID + 50,
                        "path": "/admin",
                        "title": vertical.VerticalName,
                        "type": "sub",
                        "icontype": vertical.icon,
                        "iconColor": vertical.iconColor,
                        "ab": "R",
                        "collapse": vertical.VerticalName,
                        "CssClass": "store",
                        "Active": true,
                        "children": [],
                        "VerticalID": vertical.VerticalID
                    };
                    this.AdFeedList.forEach(adFeed => {

                        if (adFeed.VerticalID == vertical.VerticalID) {
                            var elementY = adFeed.ExchangeName;
                            var idxline1 = elementY;
                            var line1 = elementY;
                            var vChildMenuTest = {
                                "MenuID": Math.floor(Math.random() * (2000 - 1000 + 1) + 1000),
                                "path": "advertisercampaign",
                                "id": adFeed.AdFeedID,
                                "title": line1,
                                //"title2": line2,
                                "ab": "R",
                                "CssClass": 'fa fa-map-marker-alt',
                                "Active": true,
                                "type": "link"
                                //"pathMatch": 'full'
                            };
                            item.children.push(vChildMenuTest);
                        }
                    }); //End AdFeeLIst forEach
                    if (item.children.length > 0)
                        this.ROUTE2.push(item);
                });
            }
        }

        this.menuItems = this.ROUTE2;
        this.generateBreadcrumbFromMenuItems();

    }



    generateBreadcrumbFromMenuItems() {
        var breadcrumbsSidebar = []; // Asegurarse de que los breadcrumbs estén vacíos

        this.menuItems.forEach(menu => {
            if (menu.children && menu.children.length > 0) {
                menu.children.forEach(child => {
                    breadcrumbsSidebar.push({
                        component: child.path, // El path del child
                        breadcrumb: menu.title, // Título del padre
                        child: child.title,      // Título del hijo
                        id: child.id
                    });
                });
            }
        });
        this.setBreadcrumb(breadcrumbsSidebar); // Establece los breadcrumbs
        //console.log('Breadcrumbs:', JSON.stringify(breadcrumbsSidebar)); // Para verificar que se ha construido correctamente
    }


    getListVertical(): void {
        this.apiService.getVerticalList()
            .then((results: any) => {
                this.VerticalList = [];
                this.VerticalList = results.Value;
                this.VerticalList = this.VerticalList.filter(v => v.Active == true);

                if (this.VerticalList.length > 0) {
                    this.VerticalList.sort((a, b) => (a.VerticalName > b.VerticalName) ? 1 : -1);
                }

                // Aquí cargamos el JSON de los iconos
                const verticalIcons = this.apiJsonService.VerticalIcons();  // Ahora devuelve el array

                this.VerticalList.forEach(vertical => {
                    const matchedIcon = verticalIcons.find((iconData: any) => iconData.VerticalID === vertical.VerticalID);
                    if (matchedIcon) {
                        vertical.icon = matchedIcon.Icon;  // Asignamos el icono correspondiente
                        vertical.iconColor = matchedIcon.IconColor;  // Asignamos el color del ícono
                    }
                });

                // Lógica para la asignación de ad feeds y roles, permanece igual
                if (this.RoleID === 1) {
                    this.apiService.getAdFeedList()
                        .then((results: any) => {
                            const feedList = results.Value;
                            this.AdFeedList = feedList.filter(adFeed => adFeed.Visible);
                            this.AdFeedList.sort((a, b) => (a.AdFeedName.toUpperCase() > b.AdFeedName.toUpperCase()) ? 1 : -1);
                            this.SetVerticalWithAdFeed();
                        })
                        .catch(err => {
                            console.log('Error en AdFeedList RoleID 1:', err);
                        });
                }

                if (this.RoleID === 3) {
                    this.apiService.GetAdFeedOfMenuByPublisher(this.myItemSession.PublisherID)
                        .then((results: any) => {
                            const feedList = results.Value;
                            this.AdFeedList = feedList.filter(adFeed => adFeed.Visible);
                            this.AdFeedList.sort((a, b) => (a.AdFeedName.toUpperCase() > b.AdFeedName.toUpperCase()) ? 1 : -1);
                            this.SetVerticalWithAdFeed();
                        })
                        .catch(err => {
                            console.log('Error en GetAdFeedOfMenuByPublisher RoleID 3:', err);
                        });
                }

                if (this.RoleID === 2 || this.RoleID === 5) {
                    this.apiService.getAdFeedListByUser(this.myItemSession.UserID)
                        .then((results: any) => {
                            const feedList = results.Value;
                            this.AdFeedList = feedList.filter(adFeed => adFeed.Visible);
                            this.AdFeedList.sort((a, b) => (a.AdFeedName.toUpperCase() > b.AdFeedName.toUpperCase()) ? 1 : -1);
                            this.SetVerticalWithAdFeed();
                        })
                        .catch(err => {
                            console.log('Error en getAdFeedListByUser RoleID 2/5:', err);
                        });
                }
            })
            .catch(err => {
                console.log('Error en getListVertical:', err);
            });
    }



    CreateRouteInfoGeneral(menus) {
        this.breadCrumbList = [];

        let myItemSession = localStorage.getItem("SessionMAO");
        let obj = JSON.parse(myItemSession);
        this.UserName = obj.name;
        this.InitName = this.UserName.trim().substring(0, 1).toUpperCase();

        // Level one menu items
        var ParentMenu = menus.filter(x => x.FatherID == null);

        var GeneralMenu = [];


        ParentMenu.forEach(element => {

            var parentTemp = {
                "MenuID": element.MenuID,
                "path": element.ComponentName,
                "title": element.Menu,
                "type": "",
                "icontype": element.CssClass,
                "ab": "R",
                "collapse": element.Menu.toLowerCase(),
                "CssClass": element.CssClass,
                "Active": element.Active,
                "children": []
            }

            // Level 2 menu items 
            var children: any[] = menus.filter(y => y.FatherID == element.MenuID);

            const hasCrildren = children.length > 0;

            if (hasCrildren) {
                parentTemp.type = "sub";

                children = children.map(lvl2MenuItem => {
                    return {
                        MenuID: lvl2MenuItem.MenuID,
                        path: lvl2MenuItem.ComponentName,
                        title: lvl2MenuItem.Menu,
                        type: "link",
                        ab: "R",
                        collapse: lvl2MenuItem.Menu.toLowerCase(),
                        CssClass: lvl2MenuItem.CssClass,
                        Active: lvl2MenuItem.Active,
                        children: []
                    }
                })

                parentTemp.children = children;
                parentTemp.children = parentTemp.children.sort((a, b) => a['title'] > b['title'] ? 1 : a['title'] === b['title'] ? 0 : -1);
            }
            else {
                parentTemp.type = "link";
            }


            if (hasCrildren) {

                children.forEach(childItem => {

                    // Level 3 menu items
                    let subChildItems = menus.filter(menuItem => menuItem.FatherID == childItem.MenuID);

                    if (subChildItems.length > 0) {
                        childItem.type = "sub";

                        subChildItems = subChildItems.map(menuItem => {
                            return {
                                MenuID: menuItem.MenuID,
                                path: menuItem.ComponentName,
                                title: menuItem.Menu,
                                tpye: "",
                                ab: "R",
                                CssClass: menuItem.CssClass,
                                Active: menuItem.Active,
                            }
                        });
                    } else {
                        childItem.type = "link"
                    }
                    childItem.children = subChildItems;
                });

            }

            if (parentTemp.MenuID == 9) {
                parentTemp.type = "sub";
            }
            GeneralMenu.push(parentTemp);
        });


        //---------------------------------
        var idx = GeneralMenu.findIndex(function (element) {
            return element.MenuID == 9
        })
        //---------------------------
        this.ROUTE2 = GeneralMenu;
        this.getListVertical();
    }


    copyMessage(val: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    // Método utilitario para filtrar el menú
    private filterMenuByPublisher(menuJson: any[], publisherId: number | null | undefined): any[] {
        if (!Array.isArray(menuJson)) return [];

        if (publisherId === 22) {
            return menuJson.filter((menuItem: any) =>
                menuItem && menuItem.Menu !== 'Lead Report' && menuItem.ComponentName !== 'leadreports'
            );
        }

        return menuJson;
    }


    getListMenu(): void {
        let userStr = localStorage.getItem("SessionMAO");
        let UserObj = $.parseJSON(userStr);

        //this.apiService.getMenuByUser(UserObj.UserID)
        this.apiService.getMenuByUser_SP(UserObj.UserID)
            .then((results: any) => {
                this.MenuList = [];
                this.MenuList = this.filterMenuByPublisher(results.Value, UserObj.PublisherID);
                this.CreateRouteInfoGeneral(this.MenuList);
            })
            .catch(err => {
                if (err.status == 401) {
                    //this._router.navigate(['/']);
                    this.Logout();
                }
                console.log('Error getListMenu', err)
            }
            );
    }

    refreshComponent() {
        window.location.reload();
    }

    breadcrumb(childitem, menuitem) {
        //alert(menuitem+"> " + childitem);
        let breadCrumbClick = menuitem + "> " + childitem;
        this.data.setBreadCrumbData(JSON.stringify(breadCrumbClick));
    }

    setBreadcrumb(data) {
        let key = "breadcrumbs-MAO";
        localStorage.setItem(key, JSON.stringify(data));
        //alert(menuitem+"> " + childitem);
        this.data.setBreadCrumbData(JSON.stringify(data));

    }

    BackImpersonate(_user: string, _pass: string, _email: string) {
        var email = "";

        this.userAuth.LogIn(_email, _pass, false)
            .subscribe(
                post => {
                    let userID: number;
                    userID = parseInt(_user);
                    var results: any;
                    results = post;
                    if (results.code == 0) {
                        let key = "SessionMAO";
                        var valueSession = {}
                        sessionStorage.setItem(key, JSON.stringify(valueSession)); //20200422
                        email = _email;
                        key = "SessionMAO";

                        var currentUser = this.myItemSession.UserID;
                        valueSession = {
                            validate: 'true',
                            name: (results.Value.FirstName + " " + results.Value.LastName),
                            UserID: results.Value.UserID,
                            CompanyID: results.Value.CompanyID,
                            PublisherID: results.Value.PublisherID,
                            RoleID: results.Value.RoleID,
                            VerticalID: results.Value.VerticalID,
                            Token: results.Value.Token,
                            ExpiresOn: results.Value.ExpiresOn,
                            Email: email.toLowerCase(),
                            RoleName: results.Value.RoleName
                        };
                        localStorage.setItem(key, JSON.stringify(valueSession));


                        if (results.Value.RoleID == 1 || results.Value.RoleID == 2 || results.Value.RoleID == 3) {
                            this._router.navigate(['/admin/dynamicdashboard']);
                        } else {
                            this._router.navigate(['/dashboards']);
                        }
                        setTimeout(() => {
                            this.refreshComponent();
                        }, 1300);


                    }
                    else {
                        let key = "SessionMAO";
                        let valueSession = { validate: 'false', name: '' }
                        //sessionStorage.setItem(key,JSON.stringify(valueSession)); //20200422
                        localStorage.setItem(key, JSON.stringify(valueSession));
                    }
                    // **** 2024-09-12 JFRH: Register Impersonate User Logout to AdminUILog log table
                    var _loggedUserID = this.LoggedUser.LoggedUserID;
                    var _loggedUserName = this.LoggedUser.LoggedUserName;
                    var _loggedUserEmail = this.LoggedUser.LoggedUserEmail;
                    var _verticalID = this.LoggedUser.VerticalID;
                    var _publisherID = this.LoggedUser.PublisherID;
                    var _subModuleName = 'User Logout (Impersonate)';
                    var _logComment = 'Logout successful (Impersonate)';
                    this.SaveLogoutAdminLog(_loggedUserID, _loggedUserName, _loggedUserEmail, _verticalID, _publisherID, _subModuleName, _logComment);
                });
    }

    ImpersonateUser(User: any) {
        var UserID = User;
        //this.apiService.getAuthUsersIDs(UserID)
        this.apiService.getAuthUsersIDs(UserID)
            .then((results: any) => {
                var result = results.Value;
                if (result != null) {
                    var Email = result.Email;
                    this.BackImpersonate(UserID, result.PasswordHash, Email);
                }
                else {
                    return;
                }
            })
            .catch(err => {
                console.log("error : " + err);

            });
    }

    Logout() {
        let key = "SessionMAO";
        let valueSession = {};
        if (this.myItemSession.Impersonate != undefined) {
            if (this.myItemSession.Impersonate == false) {
                if (this.myItemSession.CurrentUser != undefined) {
                    //this._collaborator.Impersonate()
                    // **** 2024-09-12 JFRH: Save UserID, UserName, UserEmail, VerticalID, and PublisherID from currently logged (Impersonated) user, in this.LoggedUser for saving in AdminUILog
                    this.LoggedUser = {
                        LoggedUserID: this.myItemSession.UserID,
                        LoggedUserName: this.myItemSession.name,
                        LoggedUserEmail: this.myItemSession.Email,
                        VerticalID: this.myItemSession.VerticalID,
                        PublisherID: this.myItemSession.PublisherID
                    };
                    this.ImpersonateUser(this.myItemSession.CurrentUser);
                }
                else {
                    valueSession = { validate: 'false', name: " " }
                    localStorage.setItem(key, JSON.stringify(valueSession));
                    this._router.navigate(['/']);
                }
                //localStorage.setItem(key, JSON.stringify(this.myItemSession));  

            }
        }
        else {
            // **** 2024-09-11 JFRH: Register normal User Logout to AdminUILog log table
            var _subModuleName = 'User Logout';
            var _logComment = 'Logout successful';
            this.SaveLogoutAdminLog(this.myItemSession.UserID, this.myItemSession.name, this.myItemSession.Email, this.myItemSession.VerticalID, this.myItemSession.PublisherID, _subModuleName, _logComment);
            valueSession = { validate: 'false', name: " " }
            localStorage.setItem(key, JSON.stringify(valueSession));
            this._router.navigate(['/']);
        }

    }

    /**
     * Description: Saves User Logout event in AdminUILog table
     * @param UserID 
     * @param UserName 
     * @param UserEmail 
     * @param VerticalID 
     * @param PublisherID 
     * @param SubModuleName
     * @param LogComment
     */
    SaveLogoutAdminLog(UserID: number, UserName: string, UserEmail: string, VerticalID: number, PublisherID: number, SubModuleName: string, LogComment: string) {
        var _moduleName = 'Login Status';
        var _subModuleName = SubModuleName;
        var _logEventTypeID = 8;
        var _userName = UserName.trim();
        var _itemID = UserID;
        var _addedBy = UserEmail + ' [' + _userName + ']';
        var _userID = UserID;
        var _fieldName = '(none)';
        var _newValue = null;
        var _logComment = LogComment;
        var _moduleUIID = 9;
        // Crear objeto con valores de los campos para la tabla AdminUILog
        var adminUILog = {
            "AdminUILogID": 0,
            "ModuleName": _moduleName,
            "SubModuleName": _subModuleName,
            "ItemID": _itemID,
            "AddedBy": _addedBy,
            "UserID": _userID,
            "UserIP": null,
            "DateAdded": null,
            "LogEventTypeID": _logEventTypeID,
            "FieldName": _fieldName,
            "OldValue": null,
            "NewValue": _newValue,
            "Comments": _logComment,
            "ModuleUIID": _moduleUIID,                              // ModuleUIID = 9 para modulo 'Login'
            "VerticalID": VerticalID == 0 ? null : VerticalID,      // VerticalID se asigna aquí como null, y no en método API SaveLog() en backend
            "PublisherID": PublisherID == 0 ? null : PublisherID,   // PublisherID se asigna aquí como null,  y no en método API SaveLog() en backend
        };

        this.userAuth.saveAdminLogUnauthent(adminUILog).subscribe(post => {
            var postResult: any;
            postResult = post;
            if (postResult.code == 0) {
                return;
            }
            else {
                console.log("Error <saveAdminLogUnauthent>: " + postResult.technicalDescription);
            }
        });


    }

    myProfile() {
        this._router.navigate(['/pages/profile']);


    }




    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            let ps = new PerfectScrollbar(elemSidebar, { wheelSpeed: 2, suppressScrollX: true });
        }
    }

    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}



